import cn from 'classnames';
import FINSIGHT_URLS from '@/finsight/Router/urlConstants';
import { Link } from '@/Framework/Router/Next/Link';
import IconEmailAlerts from '@dealroadshow/uikit/core/components/Icon/IconEmailAlerts';

import menuStyles from '@/Framework/UI/Organisms/ProfileWidget/Menu/menu.scss';
import { iconStyles as commonIconStyles } from '@dealroadshow/uikit/core/components/Icon';

interface ISubscriptionsMenuItemProps {
  onCloseMenu: () => void,
}

const SubscriptionsMenuItem = ({ onCloseMenu }: ISubscriptionsMenuItemProps) => {
  const prefixIconStyles = cn(menuStyles.prefixIcon, commonIconStyles.smallIcon);

  return (
    <Link
      dataTest="emailSubscriptionsLink"
      to={ FINSIGHT_URLS.SUBSCRIPTIONS }
      onClick={ onCloseMenu }
    >
      <IconEmailAlerts className={ prefixIconStyles } />
      Email Subscriptions
    </Link>
  );
};

export default SubscriptionsMenuItem;
